module.exports = __webpack_public_path__ + "static/6305-woodrose-4-d0ec95d8352be9c844b2dc264b2acab6.jpg";